import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classnames from 'classnames';
import basketIcon from 'assets/svg/basket.svg';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { Container } from 'swag-client-common/components/ui/container';
import Block from 'swag-client-common/components/ui/block';
import { SnackBar } from 'swag-client-common/components/info/snackbar';
import { RectangleInput } from 'swag-client-common/components/inputs/rectangle-input';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import classes from './api-settings.scss';
const ApiSettings = ({
  onRedirectUrlAdd,
  onRedirectUrlDelete,
  onResetApiCredentials,
  redirectUrls,
  apiClientSecret,
  apiClientKey,
  isLoading
}) => {
  let timer;
  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }
  }, []);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [snackbarMessage, changeSnackbarMessage] = useState('');
  const onNewUrlChange = e => {
    e.preventDefault();
    setRedirectUrl(e.target.value);
  };
  const onAddButtonClick = () => {
    onRedirectUrlAdd(redirectUrl);
    setRedirectUrl('');
  };
  const onCopyButtonClick = msg => {
    changeSnackbarMessage(msg);
    timer = setTimeout(() => {
      changeSnackbarMessage('');
    }, 3000);
  };
  return /*#__PURE__*/React.createElement(Container, {
    innerClassName: classes.innerContainer
  }, /*#__PURE__*/React.createElement(Block, {
    className: classes.blockContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Public API Settings"), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "Check our", ' ', /*#__PURE__*/React.createElement("a", {
    className: classes.link,
    target: "_blank",
    rel: "noopener noreferrer",
    href: APP_ROUTES.DEVELOPMENT_PORTAL
  }, "Developer Portal"), ' ', "to get started using the Swag.com Public API."), /*#__PURE__*/React.createElement("div", {
    className: classes.blockRow
  }, /*#__PURE__*/React.createElement(RectangleInput, {
    formType: "text",
    dataInput: "ClientId",
    className: classes.blockInput,
    input: {
      value: apiClientKey
    },
    disabled: true,
    label: "Client ID"
  }), /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: apiClientKey,
    onCopy: () => onCopyButtonClick('Client ID copied to a clipboard')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.inputActionButton, classes.adjustButtonForLabel),
    "data-button": "CopyId"
  }, "Copy"))), /*#__PURE__*/React.createElement("div", {
    className: classes.blockRow
  }, /*#__PURE__*/React.createElement(RectangleInput, {
    formType: "text",
    dataInput: "ClientSecret",
    className: classes.blockInput,
    placeholder: "******************************",
    disabled: true,
    label: "Client Secret"
  }), /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: apiClientSecret,
    onCopy: () => onCopyButtonClick('Client Secret copied to a clipboard')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.inputActionButton, classes.adjustButtonForLabel),
    "data-button": "CopySecret"
  }, "Copy"))), /*#__PURE__*/React.createElement("div", {
    className: classes.link,
    onClick: onResetApiCredentials,
    "data-button": "ResetCreds"
  }, "Reset API Credentials"), /*#__PURE__*/React.createElement("hr", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Redirect URLs:"), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "A list of redirect URLs accepted by the API."), redirectUrls.map(redirectUrl => /*#__PURE__*/React.createElement("div", {
    key: redirectUrl.id,
    className: classes.blockRow
  }, /*#__PURE__*/React.createElement(RectangleInput, {
    formType: "text",
    dataInput: "RedirectUrl",
    className: classes.blockInput,
    input: {
      value: redirectUrl.url
    },
    disabled: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.deleteButtonContainer,
    onClick: () => onRedirectUrlDelete(redirectUrl.id),
    "data-button": "DeleteUrl"
  }, /*#__PURE__*/React.createElement("img", {
    src: basketIcon
  })))), redirectUrls.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "You don't have any redirect URL. Start with adding a new one."), /*#__PURE__*/React.createElement("hr", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Add a Redirect URL"), /*#__PURE__*/React.createElement("div", {
    className: classes.blockRow
  }, /*#__PURE__*/React.createElement(RectangleInput, {
    formType: "text",
    dataInput: "NewRedirectUrl",
    className: classes.blockInput,
    input: {
      value: redirectUrl,
      onChange: onNewUrlChange
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.inputActionButton,
    onClick: onAddButtonClick,
    "data-button": "AddUrl"
  }, "Add"))), /*#__PURE__*/React.createElement(SnackBar, {
    open: !!snackbarMessage,
    message: snackbarMessage
  }), /*#__PURE__*/React.createElement(LoadingOverlay, {
    isShown: isLoading
  }));
};
export { ApiSettings };